angular.module('website').controller('website.galleryCtrl', ["$scope", "$stateParams", "$http", "$document", "ngTableParams", function($scope, $stateParams, $http, $document, ngTableParams) {
  return $scope.tableParams = new ngTableParams({
    page: 1,
    count: 10
  }, {
    counts: [],
    total: 0,
    getData: function($defer, params) {
      var url;
      $scope.isLoading = true;
      url = `/websites/${$stateParams.domain}/gallery_images`;
      return $http.get(url, {
        params: params.url()
      }).then(function(response) {
        $document.scrollTop(0);
        $scope.isLoading = false;
        params.total(response.data.total);
        $scope.images = response.data.collection;
        return $defer.resolve(response.data.collection);
      });
    }
  });
}]);
